module.exports = __webpack_public_path__ + "img/pageleft.6789e29e.svg";